(function () {
  'use strict';

  const CONFIG = {
    calculationMethod: 1,
    school: 1,

    pdfLibs: {
      jspdf: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js',
      autotable: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf-autotable/3.5.25/jspdf.plugin.autotable.min.js'
    },

    targetCities: [
      {
        id: 'birmingham',
        name: 'Birmingham',
        country: 'United Kingdom',
        latitude: 52.4862,
        longitude: -1.8904,
        timezone: 'Europe/London'
      },
      {
        id: 'leeds',
        name: 'Leeds',
        country: 'United Kingdom',
        latitude: 53.8008,
        longitude: -1.5491,
        timezone: 'Europe/London'
      },
      {
        id: 'wakefield',
        name: 'Wakefield',
        country: 'United Kingdom',
        latitude: 53.6833,
        longitude: -1.4977,
        timezone: 'Europe/London'
      },
      {
        id: 'manchester',
        name: 'Manchester',
        country: 'United Kingdom',
        latitude: 53.4808,
        longitude: -2.2426,
        timezone: 'Europe/London'
      },
      {
        id: 'bradford',
        name: 'Bradford',
        country: 'United Kingdom',
        latitude: 53.7950,
        longitude: -1.7594,
        timezone: 'Europe/London'
      },
      {
        id: 'sheffield',
        name: 'Sheffield',
        country: 'United Kingdom',
        latitude: 53.3811,
        longitude: -1.4701,
        timezone: 'Europe/London'
      },
      {
        id: 'liverpool',
        name: 'Liverpool',
        country: 'United Kingdom',
        latitude: 53.4084,
        longitude: -2.9916,
        timezone: 'Europe/London'
      },
      {
        id: 'london',
        name: 'London',
        country: 'United Kingdom',
        latitude: 51.5074,
        longitude: -0.1278,
        timezone: 'Europe/London'
      },
      {
        id: 'leicester',
        name: 'Leicester',
        country: 'United Kingdom',
        latitude: 52.6369,
        longitude: -1.1398,
        timezone: 'Europe/London'
      },
      {
        id: 'nottingham',
        name: 'Nottingham',
        country: 'United Kingdom',
        latitude: 52.9548,
        longitude: -1.1581,
        timezone: 'Europe/London'
      },
      {
        id: 'bristol',
        name: 'Bristol',
        country: 'United Kingdom',
        latitude: 51.4545,
        longitude: -2.5879,
        timezone: 'Europe/London'
      },
      {
        id: 'glasgow',
        name: 'Glasgow',
        country: 'United Kingdom',
        latitude: 55.8642,
        longitude: -4.2518,
        timezone: 'Europe/London'
      },
      {
        id: 'edinburgh',
        name: 'Edinburgh',
        country: 'United Kingdom',
        latitude: 55.9533,
        longitude: -3.1883,
        timezone: 'Europe/London'
      },
      {
        id: 'newcastle',
        name: 'Newcastle',
        country: 'United Kingdom',
        latitude: 54.9783,
        longitude: -1.6178,
        timezone: 'Europe/London'
      },
      {
        id: 'cardiff',
        name: 'Cardiff',
        country: 'United Kingdom',
        latitude: 51.4816,
        longitude: -3.1791,
        timezone: 'Europe/London'
      }
    ],

    prayers: [
      { key: 'Fajr', label: 'Fajr', emoji: '🌅' },
      { key: 'Sunrise', label: 'Sunrise', emoji: '☀️' },
      { key: 'Dhuhr', label: 'Dhuhr', emoji: '🕛' },
      { key: 'Asr', label: 'Asr', emoji: '🌤️' },
      { key: 'Maghrib', label: 'Maghrib', emoji: '🌇' },
      { key: 'Isha', label: 'Isha', emoji: '🌙' }
    ],

    actualPrayers: [
      'Fajr',
      'Dhuhr',
      'Asr',
      'Maghrib',
      'Isha'
    ]
  };

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getApiDate(date) {
    return [
      pad(date.getDate()),
      pad(date.getMonth() + 1),
      date.getFullYear()
    ].join('-');
  }

  function formatTime(time) {
    if (!time) return '--';

    const clean = String(time)
      .replace(/\s*\(.+\)$/, '')
      .trim();

    const parts = clean.split(':');

    if (parts.length < 2) return clean;

    let hours = parseInt(parts[0], 10);
    const minutes = parts[1];

    if (Number.isNaN(hours)) return clean;

    const period = hours >= 12 ? 'PM' : 'AM';

    hours %= 12;

    if (hours === 0) hours = 12;

    return `${hours}:${minutes} ${period}`;
  }

  function timeToMinutes(time) {
    if (!time) return null;

    const parts = String(time)
      .replace(/\s*\(.+\)$/, '')
      .trim()
      .split(':');

    if (parts.length < 2) return null;

    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
      return null;
    }

    return hours * 60 + minutes;
  }

  function formatDisplayDate(date, timezone) {
    try {
      return new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: timezone
      }).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(date);
    }
  }

  function getTimePartsInTimezone(timezone) {
    const now = new Date();

    try {
      const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });

      const parts = formatter.formatToParts(now);
      const result = {};

      parts.forEach(function (part) {
        if (part.type !== 'literal') {
          result[part.type] = parseInt(part.value, 10);
        }
      });

      return result;
    } catch (error) {
      const local = new Date();

      return {
        year: local.getFullYear(),
        month: local.getMonth() + 1,
        day: local.getDate(),
        hour: local.getHours(),
        minute: local.getMinutes(),
        second: local.getSeconds()
      };
    }
  }

  /*
   * Today's date in the city (not on the
   * visitor's device), at local midnight.
   */
  function getCityToday(timezone) {
    const parts =
      getTimePartsInTimezone(timezone);

    return new Date(
      parts.year,
      parts.month - 1,
      parts.day
    );
  }

  function getCurrentMinutes(timezone) {
    const parts = getTimePartsInTimezone(timezone);

    return (
      parts.hour * 60 +
      parts.minute +
      parts.second / 60
    );
  }

  function getPrayerOpts(city, signal) {
    return {
      latitude: city.latitude,
      longitude: city.longitude,
      method: CONFIG.calculationMethod,
      school: CONFIG.school,
      signal: signal
    };
  }

  function setLoading(root, loading) {
    const element = root.querySelector(
      '[data-salah-loading]'
    );

    if (element) {
      element.hidden = !loading;
    }
  }

  function showError(root, message) {
    const element = root.querySelector(
      '[data-salah-error]'
    );

    if (!element) return;

    element.textContent = message;
    element.hidden = false;
  }

  function hideError(root) {
    const element = root.querySelector(
      '[data-salah-error]'
    );

    if (!element) return;

    element.hidden = true;
    element.textContent = '';
  }

  function showStatus(root, message) {
    const element = root.querySelector(
      '[data-salah-status]'
    );

    if (!element) return;

    element.textContent = message;
    element.hidden = !message;
  }

  function updateCityText(root, city) {
    root
      .querySelectorAll(
        '[data-salah-title-city], [data-salah-hero-city]'
      )
      .forEach(function (element) {
        element.textContent = city;
      });
  }

  function updateLocation(
    root,
    name,
    country
  ) {
    const value = country
      ? `${name}, ${country}`
      : name;

    const select = root.querySelector(
      '[data-salah-city]'
    );

    if (
      select &&
      select.value === 'current-location'
    ) {
      select.setAttribute(
        'aria-label',
        `Current location: ${value}`
      );
    }
  }

  function updateDate(
    root,
    date,
    timezone
  ) {
    const element = root.querySelector(
      '[data-salah-date]'
    );

    if (element) {
      element.textContent =
        formatDisplayDate(
          date,
          timezone
        );
    }
  }

  function getPrayerState(
    timings,
    timezone
  ) {
    if (!timezone) return null;

    const currentMinutes =
      getCurrentMinutes(timezone);

    const prayers = CONFIG.actualPrayers
      .map(function (key) {
        return {
          key: key,
          time: timings[key],
          minutes: timeToMinutes(
            timings[key]
          )
        };
      })
      .filter(function (item) {
        return item.minutes !== null;
      });

    if (!prayers.length) return null;

    const nextPrayer = prayers.find(
      function (prayer) {
        return (
          prayer.minutes >
          currentMinutes
        );
      }
    );

    if (!nextPrayer) {
      return {
        current:
          prayers[prayers.length - 1],

        next: prayers[0],

        nextTomorrow: true
      };
    }

    let currentPrayer = null;

    prayers.forEach(function (prayer) {
      if (
        prayer.minutes <=
        currentMinutes
      ) {
        currentPrayer = prayer;
      }
    });

    if (!currentPrayer) {
      currentPrayer =
        prayers[prayers.length - 1];
    }

    /*
     * Fajr's time ends at sunrise; no prayer
     * is current again until Dhuhr.
     */
    const sunrise =
      timeToMinutes(timings.Sunrise);

    if (
      currentPrayer.key === 'Fajr' &&
      sunrise !== null &&
      currentMinutes >= sunrise
    ) {
      currentPrayer = null;
    }

    return {
      current: currentPrayer,
      next: nextPrayer,
      nextTomorrow: false
    };
  }

  function getMinutesUntilNextPrayer(
    prayerMinutes,
    timezone,
    tomorrow
  ) {
    const current =
      getCurrentMinutes(timezone);

    if (tomorrow) {
      return (
        (24 * 60 - current) +
        prayerMinutes
      );
    }

    return prayerMinutes - current;
  }

  function formatCountdown(
    totalMinutes
  ) {
    if (
      totalMinutes === null ||
      totalMinutes < 0
    ) {
      return '--';
    }

    const rounded =
      Math.ceil(totalMinutes);

    const hours =
      Math.floor(rounded / 60);

    const minutes =
      rounded % 60;

    if (hours <= 0) {
      return `${minutes} min`;
    }

    if (minutes <= 0) {
      return `${hours} hr`;
    }

    return `${hours} hr ${minutes} min`;
  }

  const PRAYER_STATUS_LABELS = {
    current: 'Now',
    next: 'Next',
    passed: 'Passed'
  };

  /*
   * 'current', 'next', 'passed', or '' for a
   * prayer still to come later today.
   */
  function getPrayerStatus(
    prayerKey,
    timings,
    state,
    timezone
  ) {
    if (!state || !timezone) return '';

    if (
      state.current &&
      state.current.key === prayerKey
    ) {
      return 'current';
    }

    if (
      !state.nextTomorrow &&
      state.next &&
      state.next.key === prayerKey
    ) {
      return 'next';
    }

    const minutes =
      timeToMinutes(
        timings[prayerKey]
      );

    if (
      minutes !== null &&
      minutes <=
        getCurrentMinutes(timezone)
    ) {
      return 'passed';
    }

    return '';
  }

  function createPrayerStatus(status) {
    const badge =
      document.createElement('span');

    badge.className =
      `salah-times__prayer-status salah-times__prayer-status--${status || 'empty'}`;

    if (status) {
      badge.textContent =
        PRAYER_STATUS_LABELS[status];
    } else {
      badge.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    return badge;
  }

  function renderPrayerTimes(
    root,
    timings
  ) {
    const container =
      root.querySelector(
        '[data-salah-prayers]'
      );

    if (!container) return;

    const state =
      getPrayerState(
        timings,
        root._salahCurrentData?.timezone
      );

    const currentKey =
      state?.current?.key || '';

    const fragment =
      document.createDocumentFragment();

    CONFIG.prayers.forEach(
      function (prayer) {
        const item =
          document.createElement('div');

        item.className =
          'salah-times__prayer';

        if (
          prayer.key === currentKey
        ) {
          item.classList.add(
            'is-current'
          );
        }

        const status =
          getPrayerStatus(
            prayer.key,
            timings,
            state,
            root._salahCurrentData?.timezone
          );

        if (status === 'passed') {
          item.classList.add(
            'is-passed'
          );
        }

        const name =
          document.createElement('span');

        name.className =
          'salah-times__prayer-name';

        const emoji =
          document.createElement('span');

        emoji.className =
          'salah-times__prayer-emoji';

        emoji.setAttribute(
          'aria-hidden',
          'true'
        );

        emoji.textContent =
          prayer.emoji || '';

        const label =
          document.createElement('span');

        label.textContent =
          prayer.label;

        name.appendChild(emoji);
        name.appendChild(label);

        const time =
          document.createElement('span');

        time.className =
          'salah-times__prayer-time';

        time.textContent =
          formatTime(
            timings[prayer.key]
          );

        item.appendChild(
          createPrayerStatus(status)
        );

        item.appendChild(name);
        item.appendChild(time);

        fragment.appendChild(item);
      }
    );

    container.replaceChildren(
      fragment
    );
  }

  function renderPrayerState(
    root,
    timings,
    timezone
  ) {
    const nextContainer =
      root.querySelector(
        '[data-salah-next]'
      );

    if (!nextContainer) return;

    const state =
      getPrayerState(
        timings,
        timezone
      );

    if (
      !state ||
      !state.next
    ) {
      nextContainer.hidden = true;
      return;
    }

    const name =
      root.querySelector(
        '[data-salah-next-name]'
      );

    const time =
      root.querySelector(
        '[data-salah-next-time]'
      );

    const countdown =
      root.querySelector(
        '[data-salah-countdown]'
      );

    const label =
      CONFIG.prayers.find(
        function (item) {
          return (
            item.key ===
            state.next.key
          );
        }
      );

    if (name) {
      name.textContent =
        label
          ? label.label
          : state.next.key;
    }

    if (time) {
      time.textContent =
        formatTime(
          state.next.time
        );
    }

    if (countdown) {
      countdown.textContent =
        formatCountdown(
          getMinutesUntilNextPrayer(
            state.next.minutes,
            timezone,
            state.nextTomorrow
          )
        );
    }

    nextContainer.hidden = false;
  }

  function renderJumma(
    root,
    current
  ) {
    const container =
      root.querySelector(
        '[data-salah-jumma]'
      );

    if (!container) return;

    const isFriday =
      !!current &&
      current.weekday === 'Friday';

    const dhuhrTime =
      current &&
      current.timings
        ? current.timings.Dhuhr
        : null;

    if (
      !isFriday ||
      !dhuhrTime
    ) {
      container.hidden = true;
      return;
    }

    const time =
      root.querySelector(
        '[data-salah-jumma-time]'
      );

    if (time) {
      time.textContent =
        formatTime(dhuhrTime);
    }

    container.hidden = false;
  }

  function getCurrentPosition() {
    return new Promise(
      function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(
          resolve,
          reject,
          {
            enableHighAccuracy: false,
            timeout: 10000,
            maximumAge: 300000
          }
        );
      }
    );
  }

  async function useCurrentLocation(
    root
  ) {
    if (!navigator.geolocation) {
      showError(
        root,
        'Location services are not supported by your browser. Please select a city.'
      );

      return;
    }

    if (root._salahLocationLoading) {
      return;
    }

    root._salahLocationLoading = true;

    hideError(root);

    showStatus(
      root,
      'Getting your current location...'
    );

    setLoading(
      root,
      true
    );

    try {
      const position =
        await getCurrentPosition();

      if (!root.isConnected) {
        return;
      }

      const latitude =
        position.coords.latitude;

      const longitude =
        position.coords.longitude;

      if (
        root._salahAbortController
      ) {
        root._salahAbortController.abort();
      }

      const controller =
        new AbortController();

      root._salahAbortController =
        controller;

      let locationInfo;

      try {
        locationInfo =
          await window.SalahData.reverseGeocode(
            latitude,
            longitude,
            controller.signal
          );
      } catch (error) {
        if (
          error &&
          error.name === 'AbortError'
        ) {
          return;
        }

        console.warn(
          'Reverse geocoding failed:',
          error
        );

        locationInfo = {
          city:
            'Your Current Location',
          country: '',
          countryCode: ''
        };
      }

      if (
        controller.signal.aborted ||
        !root.isConnected
      ) {
        return;
      }

      const timezone =
        Intl.DateTimeFormat()
          .resolvedOptions()
          .timeZone ||
        'UTC';

      showStatus(
        root,
        `Finding the prayer times page for ${locationInfo.city}...`
      );

      const result =
        await window.SalahData.resolveCity(
          {
            city: locationInfo.city,
            country: locationInfo.country,
            countryCode:
              locationInfo.countryCode,
            latitude: latitude,
            longitude: longitude,
            timezone: timezone
          },
          controller.signal
        );

      if (
        controller.signal.aborted ||
        !root.isConnected
      ) {
        return;
      }

      window.location.href =
        result.url;
    } catch (error) {
      if (
        error &&
        error.name === 'AbortError'
      ) {
        return;
      }

      console.error(
        'Geolocation error:',
        error
      );

      if (root.isConnected) {
        showStatus(
          root,
          ''
        );

        showError(
          root,
          'Location access was not available. Please select your city instead.'
        );
      }
    } finally {
      root._salahLocationLoading =
        false;

      if (root.isConnected) {
        setLoading(
          root,
          false
        );
      }
    }
  }

  async function loadCity(
    root,
    city
  ) {
    if (
      !root ||
      !city ||
      !root.isConnected
    ) {
      return;
    }

    if (
      typeof city.latitude !== 'number' ||
      typeof city.longitude !== 'number' ||
      !Number.isFinite(
        city.latitude
      ) ||
      !Number.isFinite(
        city.longitude
      )
    ) {
      showError(
        root,
        'This city has not been configured yet.'
      );

      return;
    }

    if (
      root._salahAbortController
    ) {
      root._salahAbortController.abort();
    }

    const controller =
      new AbortController();

    root._salahAbortController =
      controller;

    const now =
      new Date();

    const today =
      getCityToday(city.timezone);

    try {
      hideError(root);

      showStatus(
        root,
        ''
      );

      setLoading(
        root,
        true
      );

      updateCityText(
        root,
        city.name
      );

      updateLocation(
        root,
        city.name,
        city.country
      );

      updateDate(
        root,
        now,
        city.timezone
      );

      const result =
        await window.SalahData.getPrayerDay(
          getPrayerOpts(
            city,
            controller.signal
          ),
          today
        );

      if (
        controller.signal.aborted ||
        !root.isConnected ||
        root._salahAbortController !==
          controller
      ) {
        return;
      }

      const timings =
        result.data.timings;

      const weekday =
        result.data.date &&
        result.data.date.gregorian &&
        result.data.date.gregorian.weekday
          ? result.data.date.gregorian.weekday.en
          : null;

      root._salahCurrentData = {
        city: city,
        timings: timings,
        weekday: weekday,
        date: today,
        timezone: city.timezone
      };

      renderPrayerTimes(
        root,
        timings
      );

      renderPrayerState(
        root,
        timings,
        city.timezone
      );

      renderJumma(
        root,
        root._salahCurrentData
      );

      if (
        result.source === 'cache'
      ) {
        showStatus(
          root,
          'Using today’s saved prayer times.'
        );
      }
    } catch (error) {
      if (
        error &&
        error.name === 'AbortError'
      ) {
        return;
      }

      console.error(
        'Salah Times Error:',
        error
      );

      if (
        root.isConnected &&
        root._salahAbortController ===
          controller
      ) {
        showError(
          root,
          'Unable to load prayer times right now. Please try again or select another city.'
        );
      }
    } finally {
      if (
        root.isConnected &&
        root._salahAbortController ===
          controller
      ) {
        setLoading(
          root,
          false
        );
      }
    }
  }

  function loadScript(src) {
    return new Promise(
      function (resolve, reject) {
        const existing =
          document.querySelector(
            `script[src="${src}"]`
          );

        if (existing) {
          if (
            existing.dataset
              .salahLoaded === 'true'
          ) {
            resolve();
            return;
          }

          existing.addEventListener(
            'load',
            function () {
              resolve();
            }
          );

          existing.addEventListener(
            'error',
            function () {
              reject(
                new Error(
                  `Failed to load ${src}`
                )
              );
            }
          );

          return;
        }

        const script =
          document.createElement(
            'script'
          );

        script.src = src;
        script.async = true;

        script.addEventListener(
          'load',
          function () {
            script.dataset.salahLoaded =
              'true';

            resolve();
          }
        );

        script.addEventListener(
          'error',
          function () {
            reject(
              new Error(
                `Failed to load ${src}`
              )
            );
          }
        );

        document.head.appendChild(
          script
        );
      }
    );
  }

  let pdfLibsPromise = null;

  function loadPdfLibraries() {
    if (!pdfLibsPromise) {
      pdfLibsPromise =
        loadScript(
          CONFIG.pdfLibs.jspdf
        )
          .then(function () {
            return loadScript(
              CONFIG.pdfLibs.autotable
            );
          })
          .catch(function (error) {
            pdfLibsPromise = null;
            throw error;
          });
    }

    return pdfLibsPromise;
  }

  /*
   * Loads the Shopify logo and converts it to a
   * data URL so jsPDF can embed it in the PDF.
   */
  function loadImageAsDataUrl(src) {
    return new Promise(
      function (resolve, reject) {
        if (!src) {
          resolve(null);
          return;
        }

        const image =
          new Image();

        image.crossOrigin =
          'anonymous';

        image.onload =
          function () {
            try {
              const canvas =
                document.createElement(
                  'canvas'
                );

              canvas.width =
                image.naturalWidth ||
                image.width;

              canvas.height =
                image.naturalHeight ||
                image.height;

              const context =
                canvas.getContext(
                  '2d'
                );

              if (!context) {
                reject(
                  new Error(
                    'Canvas is not supported.'
                  )
                );

                return;
              }

              context.drawImage(
                image,
                0,
                0
              );

              resolve(
                canvas.toDataURL(
                  'image/png'
                )
              );
            } catch (error) {
              reject(error);
            }
          };

        image.onerror =
          function () {
            reject(
              new Error(
                'Unable to load Donate Directly logo.'
              )
            );
          };

        image.src = src;
      }
    );
  }

  /*
   * PDF
   *
   * Logo appears on the LEFT.
   * "Lahore Prayer Timetable" / city title
   * appears immediately to the RIGHT of it.
   */
  async function buildTimetablePdf(
    city,
    range,
    days,
    logoUrl
  ) {
    const jsPDFCtor =
      window.jspdf &&
      window.jspdf.jsPDF;

    if (!jsPDFCtor) {
      throw new Error(
        'PDF library did not load correctly.'
      );
    }

    const doc =
      new jsPDFCtor({
        orientation: 'portrait',
        unit: 'pt',
        format: 'a4'
      });

    const rangeLabel =
      range === 'daily'
        ? 'Daily'
        : range === 'weekly'
          ? 'Weekly'
          : 'Monthly';

    const title =
      `${city.name} Prayer Timetable`;

    const subtitleParts = [
      rangeLabel
    ];

    if (city.country) {
      subtitleParts.push(
        city.country
      );
    }

    const subtitle =
      subtitleParts.join(
        ' - '
      );

    /*
     * Header dimensions.
     *
     * Logo sits on the left.
     * Title sits to the right of logo.
     */
    const headerLeft = 20;
    const logoWidth = 160;
    const logoHeight = 76;
    const logoTop = 10;

    const titleX =
      headerLeft +
      logoWidth +
      10;

    const titleY = 45;
    const subtitleY = 64;

    let logoAdded = false;

    if (logoUrl) {
      try {
        const logoDataUrl =
          await loadImageAsDataUrl(
            logoUrl
          );

        if (logoDataUrl) {
          doc.addImage(
            logoDataUrl,
            'PNG',
            headerLeft,
            logoTop,
            logoWidth,
            logoHeight
          );

          logoAdded = true;
        }
      } catch (error) {
        console.warn(
          'Donate Directly logo could not be added to PDF:',
          error
        );
      }
    }

    /*
     * If there is no logo, keep the original
     * left-aligned title position.
     */
    const finalTitleX =
      logoAdded
        ? titleX
        : headerLeft;

    doc.setFont(
      'helvetica',
      'bold'
    );

    doc.setFontSize(
      18
    );

    doc.setTextColor(
      30,
      14,
      75
    );

    doc.text(
      title,
      finalTitleX,
      titleY
    );

    doc.setFont(
      'helvetica',
      'normal'
    );

    doc.setFontSize(
      11
    );

    doc.setTextColor(
      103,
      108,
      118
    );

    doc.text(
      subtitle,
      finalTitleX,
      subtitleY
    );

    const head = [
      [
        'Date',
        'Day',
        'Fajr',
        'Sunrise',
        'Dhuhr',
        'Asr',
        'Maghrib',
        'Isha',
        "Jumu'ah"
      ]
    ];

    const body =
      days.map(
        function (day) {
          const weekday =
            day.date &&
            day.date.gregorian &&
            day.date.gregorian.weekday
              ? day.date.gregorian
                  .weekday.en
              : '';

          const dateLabel =
            day.date &&
            day.date.gregorian
              ? day.date.gregorian
                  .date
              : '';

          const timings =
            day.timings || {};

          const isFriday =
            weekday === 'Friday';

          return [
            dateLabel,
            weekday,
            formatTime(
              timings.Fajr
            ),
            formatTime(
              timings.Sunrise
            ),
            formatTime(
              timings.Dhuhr
            ),
            formatTime(
              timings.Asr
            ),
            formatTime(
              timings.Maghrib
            ),
            formatTime(
              timings.Isha
            ),
            isFriday
              ? formatTime(
                  timings.Dhuhr
                )
              : '-'
          ];
        }
      );

    /*
     * Keep enough space underneath the
     * branded header before the table.
     */
    const tableStartY =
      logoAdded
        ? 92
        : 82;

    doc.autoTable({
      head: head,
      body: body,

      startY: tableStartY,

      styles: {
        font: 'helvetica',
        fontSize: 9,
        cellPadding: 6,
        textColor: [
          30,
          14,
          75
        ]
      },

      headStyles: {
        fillColor: [
          30,
          14,
          75
        ],

        textColor: [
          255,
          255,
          255
        ]
      },

      alternateRowStyles: {
        fillColor: [
          238,
          241,
          249
        ]
      },

      margin: {
        left: 40,
        right: 40
      }
    });

    const finalY =
      (
        doc.lastAutoTable &&
        doc.lastAutoTable.finalY
      ) || tableStartY;

    doc.setFont(
      'helvetica',
      'normal'
    );

    doc.setFontSize(
      9
    );

    doc.setTextColor(
      103,
      108,
      118
    );

    doc.text(
      "Jumu'ah time is estimated from Dhuhr. Please confirm the khutbah time with your local mosque. — Donate Directly",
      40,
      finalY + 22,
      {
        maxWidth: 515
      }
    );

    const filenameCity =
      city.name
        .toLowerCase()
        .replace(
          /[^a-z0-9]+/g,
          '-'
        );

    /*
     * The timetable's first date (DD-MM-YYYY
     * from the city's calendar) as YYYY-MM-DD.
     */
    const filenameDate =
      String(
        days[0].date.gregorian.date || ''
      )
        .split('-')
        .reverse()
        .join('-');

    savePdf(
      doc,
      `salah-times-${filenameCity}-${range}-${filenameDate}.pdf`
    );
  }

  /**
   * jsPDF's doc.save() opens the PDF in a tab on iPhone/iPad
   * (Safari and Chrome both use WebKit there). A link with the
   * download attribute to a blob makes iOS show "Download"
   * instead, like Android. On iOS the blob is typed as a generic
   * file so it isn't previewed inline; the .pdf name keeps it a PDF.
   */
  function savePdf(doc, filename) {
    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' &&
        navigator.maxTouchPoints > 1);
    const blob = new Blob(
      [doc.output('arraybuffer')],
      {
        type: isIOS
          ? 'application/octet-stream'
          : 'application/pdf'
      }
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(function () {
      URL.revokeObjectURL(url);
    }, 60000);
  }

  async function downloadTimetable(
    root,
    range
  ) {
    const current =
      root._salahCurrentData;

    if (
      !current ||
      !current.timings
    ) {
      showError(
        root,
        'Prayer times are not loaded yet.'
      );

      return;
    }

    const button =
      root.querySelector(
        `[data-salah-download-pdf="${range}"]`
      );

    const originalLabel =
      button
        ? button.textContent
        : '';

    if (button) {
      button.disabled = true;
      button.textContent =
        'Preparing…';
    }

    hideError(root);

    try {
      await loadPdfLibraries();

      const city =
        current.city;

      let days;

      if (range === 'daily') {
        days = [
          {
            date: {
              gregorian: {
                date:
                  getApiDate(
                    current.date
                  ),

                weekday: {
                  en:
                    current.weekday ||
                    ''
                }
              }
            },

            timings:
              current.timings
          }
        ];
      } else if (
        range === 'weekly'
      ) {
        days =
          await window.SalahData.getDayRange(
            getPrayerOpts(city),
            current.date,
            7
          );
      } else if (
        range === 'monthly'
      ) {
        days =
          await window.SalahData.getCalendarMonth(
            getPrayerOpts(city),
            current.date.getFullYear(),
            current.date.getMonth() + 1
          );
      } else {
        throw new Error(
          'Unknown timetable range.'
        );
      }

      if (
        !days ||
        !days.length
      ) {
        throw new Error(
          'No timetable data available.'
        );
      }

      /*
       * Get the Donate Directly logo URL
       * from the Shopify section.
       */
      const logoUrl =
        root.dataset
          .salahLogoUrl || '';

      await buildTimetablePdf(
        city,
        range,
        days,
        logoUrl
      );
    } catch (error) {
      console.error(
        'Timetable download error:',
        error
      );

      showError(
        root,
        'Unable to prepare the timetable right now. Please try again.'
      );
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent =
          originalLabel;
      }
    }
  }

  function refreshPrayerStatus(
    root
  ) {
    if (
      !root ||
      !root.isConnected
    ) {
      return;
    }

    const current =
      root._salahCurrentData;

    if (
      !current ||
      !current.timings
    ) {
      return;
    }

    /*
     * Past the city's midnight: load the
     * new day's times.
     */
    if (
      getApiDate(
        getCityToday(current.timezone)
      ) !== getApiDate(current.date)
    ) {
      loadCity(
        root,
        current.city
      );

      return;
    }

    renderPrayerTimes(
      root,
      current.timings
    );

    renderPrayerState(
      root,
      current.timings,
      current.timezone
    );

    renderJumma(
      root,
      current
    );
  }

  function startStatusTimer(
    root
  ) {
    if (
      root._salahStatusTimer
    ) {
      return;
    }

    function tick() {
      if (
        !root.isConnected ||
        root.dataset
          .salahTimesInitialized !==
          'true'
      ) {
        root._salahStatusTimer =
          null;

        return;
      }

      refreshPrayerStatus(
        root
      );

      root._salahStatusTimer =
        window.setTimeout(
          tick,
          30000
        );
    }

    root._salahStatusTimer =
      window.setTimeout(
        tick,
        30000
      );
  }

  function cleanup(root) {
    if (!root) return;

    if (
      root._salahStatusTimer
    ) {
      clearTimeout(
        root._salahStatusTimer
      );

      root._salahStatusTimer =
        null;
    }

    if (
      root._salahAbortController
    ) {
      root._salahAbortController.abort();

      root._salahAbortController =
        null;
    }

    root._salahCurrentData =
      null;

    root._salahCurrentLocation =
      null;

    root._salahPredefinedCity =
      null;

    root._salahLocationLoading =
      false;
  }

  function init(root) {
    if (
      !root ||
      root.dataset
        .salahTimesInitialized ===
        'true'
    ) {
      return;
    }

    root.dataset
      .salahTimesInitialized =
      'true';

    if (!window.SalahData) {
      showError(
        root,
        'Unable to load prayer times right now. Please try again later.'
      );

      return;
    }

    const predefinedId =
      root.dataset
        .predefinedCity;

    const predefinedCity =
      CONFIG.targetCities.find(
        function (city) {
          return (
            city.id ===
            predefinedId
          );
        }
      ) ||
      CONFIG.targetCities[0];

    root._salahPredefinedCity =
      predefinedCity;

    const select =
      root.querySelector(
        '[data-salah-city]'
      );

    const locationButton =
      root.querySelector(
        '[data-salah-location-button]'
      );

    if (select) {
      select.addEventListener(
        'change',
        function () {
          const value =
            select.value;

          if (
            value ===
            'current-location'
          ) {
            useCurrentLocation(
              root
            );

            return;
          }

          /*
           * Every other option is a city
           * page's URL.
           */
          if (
            value &&
            value !== window.location.pathname
          ) {
            window.location.href = value;
          }
        }
      );
    }

    if (locationButton) {
      locationButton.addEventListener(
        'click',
        function () {
          useCurrentLocation(
            root
          );
        }
      );
    }

    root
      .querySelectorAll(
        '[data-salah-download-pdf]'
      )
      .forEach(
        function (button) {
          button.addEventListener(
            'click',
            function () {
              downloadTimetable(
                root,
                button.dataset
                  .salahDownloadPdf
              );
            }
          );
        }
      );

    // Crawlers and headless browsers would otherwise spend third-party API quota.
    if (!window.SalahData.isLikelyBot()) {
      loadCity(
        root,
        predefinedCity
      );

      window.SalahData.renderNearbyMosques(
        root.querySelector(
          '[data-salah-mosques]'
        ),
        {
          latitude: predefinedCity.latitude,
          longitude: predefinedCity.longitude,
          useMiles: true
        }
      );
    }

    startStatusTimer(
      root
    );
  }

  function handleSectionUnload(
    event
  ) {
    const section =
      event.target;

    if (!section) return;

    const root =
      section.matches(
        '[data-salah-times]'
      )
        ? section
        : section.querySelector(
            '[data-salah-times]'
          );

    if (root) {
      cleanup(root);
    }
  }

  if (
    !window
      .__salahTimesCleanupInitialized
  ) {
    window
      .__salahTimesCleanupInitialized =
      true;

    document.addEventListener(
      'shopify:section:unload',
      handleSectionUnload
    );
  }

  function initializeAll() {
    document
      .querySelectorAll(
        '[data-salah-times]'
      )
      .forEach(
        function (root) {
          init(root);
        }
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAll,
      {
        once: true
      }
    );
  } else {
    initializeAll();
  }
})();
